import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactAccNavigation, compactAppNavigation, compactCompanyNavigation, compactNavigation, compactProjectNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';
import { UserDataService } from 'app/core/datas/user-data';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _compactAccNavigation: FuseNavigationItem[] = compactAccNavigation;
    private readonly _compactAppNavigation: FuseNavigationItem[] = compactAppNavigation;
    private readonly _compactCompanyNavigation: FuseNavigationItem[] = compactCompanyNavigation;
    private readonly _compactProjectNavigation: FuseNavigationItem[] = compactProjectNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService, private _userDataSvc: UserDataService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactNavItem.id) {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                this._compactAccNavigation.forEach((compactAccNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactAccNavItem.id) {
                            compactAccNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                this._compactAppNavigation.forEach((compactAppNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactAppNavItem.id) {
                            compactAppNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });
                this._compactCompanyNavigation.forEach((compactCompanyNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactCompanyNavItem.id) {
                            compactCompanyNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                this._compactProjectNavigation.forEach((compactProjectNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactProjectNavItem.id) {
                            compactProjectNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === futuristicNavItem.id) {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Filter project navigation
                let projectNav = cloneDeep(this._compactProjectNavigation);
                const allowedRoles = ['SUV', 'STA', 'OWN'];
                const hasPermission = allowedRoles.some(role => this._userDataSvc.hasRole(role));

                if (!hasPermission) {
                    projectNav = projectNav.filter(item => item.id !== 'setting');
                }

                // Return the response
                return [
                    200,
                    {
                        compact: cloneDeep(this._compactNavigation),
                        compactAcc: cloneDeep(this._compactAccNavigation),
                        compactApp: cloneDeep(this._compactAppNavigation),
                        compactCompany: cloneDeep(this._compactCompanyNavigation),
                        compactProject: projectNav,
                        default: cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation),
                    },
                ];
            });
    }
}
